<h1 class="page-title">Import CSV</h1>

<div class="dropzone"
     [class.over]="dragOver"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave()"
     (drop)="onDrop($event)">
  <p class="dz-main">Drop Apple Card or bank CSV files here</p>
  <p class="dz-sub">Parsed in your browser — nothing is uploaded until you confirm.</p>
  <label class="dz-btn">
    Choose files
    <input type="file" accept=".csv,text/csv" multiple (change)="onPick($event)" hidden>
  </label>
</div>

<div class="cutoff-row">
  <label for="cutoff">Only import transactions on or after</label>
  <input id="cutoff" type="date" [(ngModel)]="cutoffDate" (change)="restage()">
  <span class="cutoff-note">Defaults to 24 months back. Changing it re-reads the dropped files at the new window.</span>
</div>

<p class="commit-error" *ngIf="commitError">{{ commitError }}</p>

<div class="file-card" *ngFor="let file of staged; let i = index; trackBy: trackStaged">
  <div class="file-head">
    <span class="file-name">{{ file.filename }}</span>
    <button class="link-btn" (click)="discard(i)">discard</button>
  </div>

  <p class="file-error" *ngIf="file.error">{{ file.error }}</p>

  <ng-container *ngIf="!file.error">
    <div class="counts">
      <span class="count new">{{ file.newCount }} new</span>
      <span class="count">{{ file.duplicateCount }} duplicate</span>
      <span class="count" *ngIf="file.pendingCount">{{ file.pendingCount }} pending skipped</span>
      <span class="count" *ngIf="file.skippedOldCount">
        {{ file.skippedOldCount }} before {{ cutoffDate }}
      </span>
      <span class="count muted">{{ file.dateFrom }} → {{ file.dateTo }}</span>
    </div>

    <table class="preview">
      <thead>
        <tr><th>Date</th><th>Description</th><th>Category</th><th class="right">Amount</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let t of file.txns; trackBy: trackTxn"
            [class.dupe]="t.isDuplicate"
            [class.needs-review]="!t.isDuplicate && !t.categoryId && !t.isTransfer">
          <td class="date">{{ t.date + 'T00:00:00' | date:'MMM d' }}</td>
          <td class="desc" [title]="t.description">{{ t.matchKey }}</td>
          <td>
            <span class="transfer-tag" *ngIf="t.isTransfer">Transfer</span>
            <select *ngIf="!t.isTransfer"
                    class="cat-select"
                    (change)="setCategory(t, $any($event.target).value)">
              <option value="" [selected]="!t.categoryId">Uncategorized</option>
              <option *ngFor="let c of categories; trackBy: trackCategory"
                      [value]="c.id" [selected]="c.id === t.categoryId">{{ c.name }}</option>
            </select>
            <button class="suggest"
                    *ngIf="!t.isTransfer && !t.categoryId && t.sourceCategory"
                    title="Apple's own category — a suggestion, not a rule">
              {{ t.sourceCategory }}
            </button>
          </td>
          <td class="right amount" [class.inflow]="t.amount > 0">
            {{ t.amount / 100 | currency:'USD' }}
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>

<div class="commit-bar" *ngIf="staged.length">
  <span class="progress">{{ progress }}</span>
  <button class="commit-btn" [disabled]="committing || totalNew === 0" (click)="commit()">
    {{ committing ? 'Importing…' : 'Import ' + totalNew + ' transactions' }}
  </button>
</div>

<h2 class="section-title" *ngIf="imports.length">Import history</h2>
<div class="history-row" *ngFor="let rec of imports; trackBy: trackImport">
  <span class="h-file">{{ rec.filename }}</span>
  <span class="h-meta">{{ rec.importedCount }} txns · {{ rec.dateFrom }} → {{ rec.dateTo }}</span>
  <button class="link-btn" (click)="undo(rec)">undo</button>
</div>
